import { render } from "./expandable.vue?vue&type=template&id=4f5df3ba&scoped=true"
import script from "./expandable.vue?vue&type=script&lang=js"
export * from "./expandable.vue?vue&type=script&lang=js"

import "./expandable.vue?vue&type=style&index=0&id=4f5df3ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5df3ba"]])

export default __exports__